import React from 'react';
import Textarea from 'react-textarea-autosize';
import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');
import fontFamily from '../data/font-family';

const StyledTextarea = styled(Textarea)`
  background-color: ${colors.white};
  border-radius: 4px;
  border: solid 1px ${colors.N40};
  box-sizing: border-box;
  font-family: ${fontFamily};
  font-size: 14px;
  line-height: 1.33;
  padding: 8px 8px 8px 8px;
  resize: none;
  transition: 0.05s background-color;
  width: 100%;

  &:focus {
    border: solid 2px ${colors['trello-blue-300']};
    outline: 0;
    padding: 7px;
  }
`;

export class ReplyTextarea extends React.Component {
  componentDidMount() {
    if (this.inputRef) {
      const endIndex = this.inputRef.value.length;
      this.inputRef.focus();
      // There are cross-browser inconsistencies about where the cursor is
      // after calling focus(). Always select the end of the input.
      this.inputRef.setSelectionRange(endIndex, endIndex);
    }
  }

  render() {
    return (
      <StyledTextarea
        inputRef={(ref) => (this.inputRef = ref)}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/ReplyTextarea.js